<template>
  <div class="container">
    <breadcrumb v-if="!isMobile" crumb="auto-list" />
    <section v-if="!isMobile" class="top-section">
      <el-row>
        <el-col :span="12">
          <search-input
            placeholder="Поиск по номеру, Названию организации (ИП), ИНН"
            @clear="clearFilter"
            @search="filterAutoList"
            @input="onInput"
          />
        </el-col>
        <el-col :span="12" class="top-section-right">
          <div class="center" style="justify-content: flex-end">
            <p @click="$router.push({ path: '/auto/add' })">Добавить авто</p>
          </div>
          <approve-filters
            :statistics="statusStas"
            :loading="loadingStats"
            :status="status"
            @setStatus="setStatus"
          />
        </el-col>
      </el-row>
      <p class="select-all-d">
        <el-checkbox
          v-if="filteredAutoList.length && !loading"
          v-model="checkAll"
          :indeterminate="isIndeterminate"
          @change="handleCheckAllChange"
        >
          Выбрать все
        </el-checkbox>
      </p>
    </section>
    <section v-if="isMobile" class="top-section" style="padding-bottom: 20px">
      <el-button
        type="primary"
        style="width: 100% !important"
        @click="$router.push({ path: '/auto/add' })"
      >
        Добавить авто
      </el-button>
    </section>
    <el-table
      v-if="loading || !filteredAutoList.length"
      v-loading="loading"
      :data="filteredAutoList"
      style="width: 100%; height: 40vh; margin-top: 40px"
    />
    <section v-if="filteredAutoList.length && !loading" class="middle-section">
      <el-row>
        <el-col :span="24">
          <el-checkbox-group
            v-model="checkedAutos"
            @change="handleCheckedChange"
          >
            <transition-group name="slide-fade" tag="div">
              <div
                v-for="auto in filteredAutoList"
                :key="auto.id"
                class="check-list"
              >
                <el-row>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="2">
                    <div class="check-list-time auto-list_col_centered">
                      <el-checkbox :label="auto" :value="auto" />
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="1">
                    <div class="check-list-person auto-list_col_centered">
                      <p v-if="!isOwn(auto)">
                        <b>Н</b>
                      </p>
                      <p v-if="isOwn(auto)">
                        <b style="color: green">C</b>
                      </p>
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="2">
                    <div class="check-list-person auto-list_col_centered">
                      <p>
                        <accreditation-lists-icon :approve-data="auto" />
                      </p>
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="4">
                    <div class="check-list-person auto-list_col_centered">
                      <div>
                        <p>{{ orgNameAdd(auto) }}</p>
                        <el-rate
                          v-model="rate_user"
                          disabled
                          :colors="rate_color"
                        />
                      </div>
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="3">
                    <div class="check-list-phone grey auto-list_col_centered">
                      <p v-if="auto.user">+{{ auto.user.login }}</p>
                    </div>
                  </el-col>
                  <el-col class="auto-list_col" :span="isMobile ? 16 : 2">
                    <div
                      class="check-list-autos auto-list_col_centered"
                      :style="isMobile ? 'text-align:center' : ''"
                    >
                      <div>
                        <p>{{ auto.state_numbers }}</p>
                        <p>{{ auto.state_numbers_trailer }}</p>
                      </div>
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="4">
                    <div class="check-list-person grey auto-list_col_centered">
                      <div>
                        <p>{{ auto.carrier_name }}</p>
                        <p v-if="!auto.carrier_name">Перевозчик не указан</p>
                        <el-rate
                          v-if="auto.carrier_name"
                          v-model="rate_user"
                          disabled
                          :colors="rate_color"
                        />
                      </div>
                    </div>
                  </el-col>
                  <el-col v-if="!isMobile" class="auto-list_col" :span="4">
                    <div
                      v-if="auto.name_owner"
                      class="check-list-person grey auto-list_col_centered"
                      @click="setE(auto)"
                    >
                      <div>
                        <p>{{ auto.name_owner }}</p>
                        <el-rate
                          v-model="rate_user"
                          disabled
                          :colors="rate_color"
                        />
                      </div>
                    </div>
                  </el-col>
                  <el-col class="auto-list_col" :span="isMobile ? 8 : 2">
                    <div class="rt check-list-delete auto-list_col_centered">
                      <div>
                        <el-button
                          type="danger"
                          icon="el-icon-delete"
                          circle
                          @click="confirmToDelete(auto.id)"
                        />
                        <el-button
                          type="success"
                          icon="el-icon-edit"
                          class="no-events"
                          circle
                          @click="setE(auto)"
                        />
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </transition-group>
          </el-checkbox-group>
        </el-col>
      </el-row>
    </section>

    <section
      v-if="!isMobile && filteredAutoList.length && !loading"
      class="bottom-section"
    >
      <div class="pagination">
        <pagination-custom :data="pagination" @changed="changePage" />
      </div>
      <div v-if="!isMobile" class="bottom-section-action">
        <p>Выбрано {{ checkedAutos.length }} авто</p>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(2)"
          >
            ОТКАЗАТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            style="background: #e9e9e9; color: #778ca2; border-radius: 4px"
            class="text-block"
            @click="sendApprove(1)"
          >
            УТВЕРДИТЬ
          </el-button>
        </el-col>
        <el-col class="auto-list_col" :span="4">
          <el-button
            type="info"
            plain
            :disabled="!checkedAutos.length"
            @click="confirmToDelete(null)"
          >
            <p>Удалить</p>
          </el-button>
        </el-col>
      </div>
    </section>
    <router-view />
    <auto-edit
      :edit-auto="editAuto"
      @closedCustom="setENull"
      @updated="filterAutoList"
    />
  </div>
</template>

<script>
import { DELETE_AUTO } from '@/store/actions/autos'
import { RepositoryFactory } from '@/api/RepositoryFactory'
import { getFilterStatus } from '@/helpers/functions'
import { mapActions, mapGetters } from 'vuex'
import AccreditationListsIcon from '@/components/Accreditation/AccreditationListsIcon'
import ApproveFilters from '@/components/Shared/ApproveFilters'
import AutoEdit from './Auto-edit'
import Breadcrumb from '@/components/Breadcrumbs/Breadcrumb'
import PaginationCustom from '@/components/Tables/PaginationCustom'
import SearchInput from '@/components/Shared/SearchInput'

const Approvements = RepositoryFactory.get('approvements')

export default {
  name: 'AutoList',
  components: {
    PaginationCustom,
    AutoEdit,
    Breadcrumb,
    ApproveFilters,
    SearchInput,
    AccreditationListsIcon,
  },
  props: {
    inn: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: false,
      checkedAutos: [],
      editAuto: {},
      rate_user: 3,
      curPage: 1,
      rate_color: ['#3498DB', '#3498DB', '#3498DB'],
      status: '',
      search_input: '',
    }
  },
  computed: {
    ...mapGetters({
      pagination: 'autos/getAutosPagination',
      autoList: 'autos/getAutos',
      loading: 'autos/getAutoLoading',
    }),
    statusStas() {
      return this.$store.state.autos.approvStatistics
    },
    loadingStats() {
      return this.$store.state.autos.loadingStats
    },
    filteredAutoList() {
      return this.autoList
    },
    orgNameAdd() {
      return auto => {
        if (auto.added_org) {
          return auto.added_org.short_name
        }

        return 'Н/Д'
      }
    },
    isOwn() {
      return auto => Number(auto.user_org_inn) === Number(auto.inn_owner)
    },
  },
  watch: {
    status: {
      handler: 'getAutoList',
    },
    autoList: {
      handler(val) {
        if (
          val.length === 0 &&
          this.isDriverRole &&
          String(this.search_input) === ''
        ) {
          this.$alert('У вас нет ниодного, добавленного авто. Добавьте авто.')
          this.$router.push('/auto/add')
        }
      },
    },
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    ...mapActions({
      deleteAuto: `autos/${DELETE_AUTO}`,
      fetchAutoTypes: 'autos/fetchAutoTypes',
      fetchAutosStats: 'autos/fetchAutosStats',
      fetchAutos: 'autos/fetchAutos',
      fetchFilterAutos: 'autos/fetchFilterAutos',
    }),
    async loadPage() {
      if (this.$route.query.inn) {
        this.search_input = this.$route.query.inn
        this.filterAutoList()
      } else {
        this.getAutoList()
      }
      this.checkStatusFilter()
      await this.fetchAutoTypes()
      await this.fetchAutosStats()
    },
    onInput(cur) {
      this.search_input = cur
    },
    setStatus(status) {
      this.status = status || ''
    },
    getAutoList(value) {
      const status = getFilterStatus(value)

      this.fetchAutos({ page: this.curPage, status })
    },
    changePage(page) {
      this.curPage = page
      this.filterAutoList()
    },
    filterAutoList() {
      let filterValue = String(this.search_input).trim()

      if (filterValue.length > 2) {
        this.fetchFilterAutos(filterValue)
      }
      if (!filterValue.length) {
        this.getAutoList()
      }
    },
    clearFilter() {
      this.search_input = ''
      this.changePage()
    },
    filterByStatus(status) {
      this.status = status
    },
    deleteSelectedAutos() {
      for (let index = 0; index < this.checkedAutos.length; index++) {
        const { id } = this.checkedAutos[index]

        this.deleteAuto(id)
      }
    },
    confirmToDelete(id = null) {
      this.$confirm('Вы уверены что хотите удалить?', '', {
        confirmButtonText: 'Да',
        cancelButtonText: 'Отмена',
        type: 'warning',
        customClass: this.isMobile ? 'before-del' : '',
      })
        .then(() => {
          try {
            if (id) {
              this.deleteAuto(id)
            } else {
              this.deleteSelectedAutos()
            }
          } catch (e) {
            this.$alert(e)
          }
        })
        .catch(() => {})
    },
    handleCheckAllChange(val) {
      this.checkedAutos = val ? this.autoList : []
      this.isIndeterminate = false
    },
    handleCheckedChange(value) {
      let checkedCount = value.length

      this.checkAll = checkedCount === this.autoList.length
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.autoList.length
    },
    setENull() {
      this.editAuto = { id: 0 }
    },
    setE(auto) {
      this.editAuto = auto
    },
    sendApprove(newStatus) {
      this.checkedAutos.forEach(id => {
        Approvements.postApprovements({
          link_by_rel: 'automobiles',
          link_by_id: id,
          status: newStatus,
          user_org_inn: Number(this.user.current.organization.inn),
        }).then(() => this.filterAutoList())
      })
    },
    checkStatusFilter() {
      const query = this.$route.query

      if (query.status && query.status === '0') {
        this.status = query.status
      }
    },
  },
}
</script>

<style lang="sass">
.el-message-box.before-del
  width: 90%
.top-section
  padding: 0 15px
  .select-all-d
    margin: 0
    &:hover
     cursor: pointer
     text-decoration: underline
     .el-checkbox__label
       color: #3498DB
       text-decoration: underline
  .top-section-right
    p
      font-size: 18px
      line-height: 21px
      color: #3498DB
      &:hover
        text-decoration: underline
        cursor: pointer
    .center
      display: flex
      align-items: center
      justify-content: space-between
      span
        margin-left: 14px
    .filter-auto
      ul
        list-style-type: none
        font-size: 14px
        line-height: 24px
        li
          display: flex
          align-items: center
          justify-content: space-between
          width: 250px
          margin-left: auto
          &:hover
            text-decoration: underline
            cursor: pointer

.middle-section
  .check-list
    cursor: pointer
    margin: 20px 0
    background: #fff
    align-items: center
    height: 100px
    box-shadow: 0 2px 12px 0 rgba(0,0,0,.1)
    .auto-list_col
      height: 100px
      .auto-list_col_centered
        height: 100%
        display: grid
        align-items: center
    .check-list-time
      text-align: center
    .check-list-phone
      font-size: 16px
      line-height: 21px
    .check-list-autos
      font-size: 14px
      line-height: 21px
    .check-list-action
      img
        margin: 10px
    .check-list-person
      p
        margin: 5px
        font-size: 18px
        line-height: 22px
    .grey
      color: #98A9BC

.bottom-section
  .pagination
    margin-bottom: 20px
    display: flex
    justify-content: flex-end
  .el-pagination .btn-next, .el-pagination .btn-prev
    background: transparent
  .el-dialog, .el-pager li
    background: transparent
  .bottom-section-action
    display: flex
    align-items: center
    justify-content: flex-end
    p
      font-size: 14px
      line-height: 17px
      text-transform: uppercase
      font-weight: bold
      margin: 0
    .el-button
      margin-left: 30px
      border: none
      border-radius: 0
      background: #E9E9E9
</style>
